import '../../../scss/critical.scss';
import '../../../scss/legal.scss';
import { satGlobals } from '../../qaamgo/sat/helper/sat-globals';
import { cookieHelper } from '../../qaamgo/helper/cookie';

const $ = require('jquery');
global.$ = global.jQuery = $;

$(document).ready(function () {
    import(
        /* webpackMode: "eager" */
        '../qg-main'
    ).then(function () {
        if (cookieHelper.getCookieValue('qg_consent') === 'true') {
            $('#cookie-consent').prop('checked', true);
        }

        $('.consent-toggle').click(function (e) {
            e.preventDefault();
            if (cookieHelper.getCookieValue('qg_consent') === 'true') {
                setTimeout(function () {
                    $('#cookie-consent').prop('checked', false);
                }, 100);
                document.cookie =
                    'qg_consent=false; max-age=' + 31557600 + '; path=/;domain=' + satGlobals.getCookieDomain();
            } else {
                setTimeout(function () {
                    $('#cookie-consent').prop('checked', true);
                }, 100);
                document.cookie =
                    'qg_consent=true; max-age=' + 31557600 + '; path=/;domain=' + satGlobals.getCookieDomain();
            }
        });
    });
});
